export default __webpack_public_path__ + "static/media/teamtryton.2fa773b2.jpeg";